import React, { Fragment } from 'react';
import { t } from 'Src/i18n';

import { messageFormat } from '@clubmed/utils';

const shouldShowAgeInMonth = (ageInNumberOfMonths) => ageInNumberOfMonths <= 23;
const shouldShowAgeInYearsRange = (ageMin, ageMax) =>
  !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));

export const AvailabilityAge = ({
  ageMax,
  ageMin,
  childcareLabel,
  monthsLabel,
  yearLabel,
  yearsLabel,
  timeSlot,
}) => {
  let message = '';
  if (shouldShowAgeInMonth(ageMax)) {
    message = messageFormat(monthsLabel).format({
      min: ageMin,
      max: ageMax,
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = messageFormat(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12),
    });
  } else {
    // Shows a single year age
    message = messageFormat(yearLabel).format({ fixed: Math.floor(ageMin / 12) });
  }
  let timeSlotLabel = '';

  switch (timeSlot) {
    case 'MORNING':
      timeSlotLabel = t('booking.activities.timeSlot.morningTitle');
      break;
    case 'AFTERNOON':
      timeSlotLabel = t('booking.activities.timeSlot.afternoonTitle');
      break;
    default:
      timeSlotLabel = t('booking.activities.timeSlot.allDayTitle');
      break;
  }

  return (
    <Fragment>
      {`${childcareLabel} - ${timeSlotLabel}`}
      &nbsp;
      <span className="whitespace-nowrap font-normal">({message})</span>
      &nbsp;
    </Fragment>
  );
};
